import React from 'react';

function Footer() {

  const footerStyle = {
      bottom: '0',
  };

  return (
      <footer style={footerStyle} className='d-flex justify-content-around flex-column flex-sm-row align-items-center text-center bottom border-top pt-1'>
      <p>© 2025 KyekyekuTech. All rights reserved. </p>
      <p>Developed by <a href='https://superjcybs.com'>SUPERJCYBS</a></p>
    </footer>
  );
}

export default Footer;
